module.exports = __webpack_public_path__ + "static/img/notFound.a843feec.png";